import { Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import CheckBoxEquipment from "./CheckBoxEquipment";
import { useFormikContext } from "formik";
import { AsarFormikSelect } from "@/components";

function GroupEquipment({ update = false }) {
  const [unitCountOptions] = useMemo(
    () => [
      [
        { id: "BELOW_5", label: "1 تا 5 عدد" },
        { id: "BELOW_10", label: "6 تا 10 عدد" },
        { id: "ABOVE_10", label: "بیش از 10 عدد" },
        { id: "BORROWED", label: "قرضی از دیگر گروه ها" },
      ],
    ],
    [],
  );

  const { values, setValues } = useFormikContext();
  const [customEquipsLabel, setCustomEquipsLabel] = useState([]);

  const init = useCallback(() => {
    if (values.customEquips && values.customEquips !== null)
      setCustomEquipsLabel(Object.keys(values.customEquips));
  }, [values]);

  useEffect(() => {
    if (update) {
      init();
    }
  }, [update]);

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"10px"}
        width={"100%"}
      >
        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"تجهیزات دندان پزشکی"}
        </Typography>
        <AsarFormikSelect
          label={"تعداد یونیت های دندانپزشکی"}
          name="densityUnitCount"
          data={unitCountOptions}
          placeholder="انتخاب کنید"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              restorationToothCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.restorationToothCount}
          label="تجهیزات ترمیم"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              rooterCanalCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.rooterCanalCount}
          label="تجهیزات عصب کشی"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              pullToothCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.pullToothCount}
          label="تجهیزات کشیدن"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              imagingEquipmentCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.imagingEquipmentCount}
          label="تجهیزات تصویربرداری"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"تجهیزات پزشکی"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              barometerCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.barometerCount}
          label="کاف فشارسنج"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              paravanCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.paravanCount}
          label="پاراوان"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              examinationSetCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.examinationSetCount}
          label="ست معاینه پزشکی"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              ecgCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.ecgCount}
          label="نوار قلب"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              revivingBagCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.revivingBagCount}
          label="کیف احیا و تریال اورژانس"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              glucometerCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.glucometerCount}
          label="گلوکومتر"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              bedCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.bedCount}
          label="تخت"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              monitoringCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.monitoringCount}
          label="مانیتورینگ"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              electronicShockCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.electronicShockCount}
          label="الکتروشوک"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"ست تجهیزات زنان و مامایی"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              popEsmirCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.popEsmirCount}
          label="پاپ اسمیر"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              wifeExaminationEquipmentCount: Number(
                e.target.value.replace(/\D/g, ""),
              ),
            }))
          }
          value={values.wifeExaminationEquipmentCount}
          label="تجهیزات معاینه زنان"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              geneticallyBedCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.geneticallyBedCount}
          label="تخت ژنیکولوژی"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              sonoKidCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.sonoKidCount}
          label="سونوکید"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              samplingEquipmentCount: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.samplingEquipmentCount}
          label="تجهیزات نمونه برداری"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"ست تجهیزات چشم و بینایی سنجی"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              optometryEquip1: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.optometryEquip1}
          label="تجهیزات غربالگری اولیه"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              optometryEquip3: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.optometryEquip3}
          label="اسلیت لمپ"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              optometryEquip2: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.optometryEquip2}
          label="اتورفرکتومتر"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              optometryEquip4: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.optometryEquip4}
          label="تجهیزات تجویز(رتینوسکوپ جعبه لنز)"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"ست تجهیزات گوش و سنوایی سنجی"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              audiologistEquip1: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.audiologistEquip1}
          label="تجهیزات اتوسکوپی و معاینه تخصصی گوش و حلق و بینی"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              audiologistEquip3: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.audiologistEquip3}
          label="ساکشن"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              audiologistEquip5: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.audiologistEquip5}
          label="تیمپانومتری"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              audiologistEquip2: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.audiologistEquip2}
          label="ادیتومتری غربالگری"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              audiologistEquip4: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.audiologistEquip4}
          label="ادیتومتری تشخیص و OAE و ..."
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"ست تجهیزات تصویربرداری"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              imagingEquip1: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.imagingEquip1}
          label="ماموگرافی"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              imagingEquip3: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.imagingEquip3}
          label="سونوگرافی و اکوکاردیوگرافی"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              imagingEquip2: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.imagingEquip2}
          label="رادیوگرافی"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"ست تجهیزات آزمایشگاه"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              laboratoryEquip1: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.laboratoryEquip1}
          label="میکروسکوپی"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              laboratoryEquip3: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.laboratoryEquip3}
          label="هورمونی"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              laboratoryEquip5: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.laboratoryEquip5}
          label="CBC"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              laboratoryEquip2: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.laboratoryEquip2}
          label="UA"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              laboratoryEquip4: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.laboratoryEquip4}
          label="بیوشیمی"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"ست تجهیزات رسانه‌ای"}
        </Typography>

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              mediaEquip1: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.mediaEquip1}
          label="میکروفون حرفه‌ای"
        />
        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              mediaEquip3: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.mediaEquip3}
          label="دوربین عکاسی"
        />

        <CheckBoxEquipment
          onChange={(e) =>
            setValues((prevValues) => ({
              ...prevValues,
              mediaEquip2: Number(e.target.value.replace(/\D/g, "")),
            }))
          }
          value={values.mediaEquip2}
          label="استودیو"
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"دیگر تجهیزات"}
        </Typography>

        {update &&
          values.customEquips &&
          Object.keys(values.customEquips)
            .filter((key) => customEquipsLabel.indexOf(key) !== -1)
            .map((label, index) => {
              return (
                <CheckBoxEquipment
                  key={index}
                  onChange={(e) => {
                    setValues((prevValues) => ({
                      ...prevValues,
                      customEquips: {
                        ...prevValues.customEquips,
                        [label]:
                          e !== undefined
                            ? Number(e.target.value.replace(/\D/g, ""))
                            : undefined,
                      },
                    }));
                  }}
                  value={values.customEquips[label]}
                  label={label}
                />
              );
            })}

        <CheckBoxEquipment
          onChange={(e, label) =>
            setValues((prevValues) => ({
              ...prevValues,
              customEquips: {
                ...prevValues.customEquips,
                [label]:
                  e !== undefined ? Number(e.replace(/\D/g, "")) : undefined,
              },
            }))
          }
          dynamic
        />
        <CheckBoxEquipment
          onChange={(e, label) =>
            setValues((prevValues) => ({
              ...prevValues,
              customEquips: {
                ...prevValues.customEquips,
                [label]:
                  e !== undefined ? Number(e.replace(/\D/g, "")) : undefined,
              },
            }))
          }
          dynamic
        />
        <CheckBoxEquipment
          onChange={(e, label) =>
            setValues((prevValues) => ({
              ...prevValues,
              customEquips: {
                ...prevValues.customEquips,
                [label]:
                  e !== undefined ? Number(e.replace(/\D/g, "")) : undefined,
              },
            }))
          }
          dynamic
        />
        <CheckBoxEquipment
          onChange={(e, label) =>
            setValues((prevValues) => ({
              ...prevValues,
              customEquips: {
                ...prevValues.customEquips,
                [label]:
                  e !== undefined ? Number(e.replace(/\D/g, "")) : undefined,
              },
            }))
          }
          dynamic
        />
      </Grid>
    </>
  );
}

export default GroupEquipment;
